import styles from './BeforeFirstMileTable.module.scss';
import cn from 'classnames';
import parse from 'html-react-parser';
import { BeforeProps } from '@containers/DataTable';
import { ErrorResponse } from '@api/Responses/ErrorResponse';
import {
  getApproachingDeadline,
  TApproachingDeadlineResponse,
  TProblematicFirstMileParcel
} from '@api/apiClient/problematic';
import { Text, TextSize } from '@components/Text';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

const BeforeFirstMileTable = (props: BeforeProps<TProblematicFirstMileParcel>) => {
  const { isLoading } = props;

  const { t } = useTranslation();

  const {
    data: dataGetApproachingDeadline,
    isFetching: isFetchingGetApproachingDeadline
  } = useQuery<TApproachingDeadlineResponse, ErrorResponse>({
    queryKey: ['getApproachingDeadline', 'problematicFirstMile'],
    queryFn: getApproachingDeadline,
    retry: 1
  });

  if (!isLoading && !isFetchingGetApproachingDeadline) {
    if (dataGetApproachingDeadline && dataGetApproachingDeadline.countFirstMile) {
      return (
          <div className={cn(styles.inner, styles.innerRed)}>
            <Text size={TextSize.M}>
              <b className={cn(styles.text, styles.textRed)}>
                {t('problematicParcelsPage.firstMile.notyReturnsTitle')}
              </b>
            </Text>
            <Text size={TextSize.M}>
            <span className={cn(styles.text, styles.textRed)}>
              <b>
                {dataGetApproachingDeadline.countFirstMile}
              </b>{' '}-{' '}
              {parse(t('problematicParcelsPage.firstMile.notyReturnsText'))}
            </span>
            </Text>
          </div>
      );
    }
  }
  return null;
};

export default BeforeFirstMileTable;